import Transformer from '../transformer'
import AccountTransformer from '@/transformers/users.js'

class DivisionTransformer extends Transformer {
  static fetch({ name, leader, division_supervisors: supervisorUsers,
    slug, id, division_develop: isDivisionDevelop }) {
    return {
      slug,
      id,
      name,
      supervisorUsers: AccountTransformer.fetchCollection((supervisorUsers)).filter(s => s.isActive),
      leader: AccountTransformer.fetch(leader),
      isDivisionDevelop
    }
  }

  static send({ leader, supervisorUsers, name }) {
    return {
      leader: leader.userId,
      division_supervisors: supervisorUsers.map(s => s.userId),
      name
    }
  }
}

export default DivisionTransformer
